import React from 'react';
import { Link } from 'react-router-dom';
import { FaAngleRight } from "react-icons/fa";
import BlogData from "../../data/blog/BlogData.json";
import { useSelector } from 'react-redux';
import { media_url } from '../../hooks/useBlog';
import { slugify } from '../../utils';


const allBlogData = BlogData;

const BlogListOne = ({colSize, itemShow}) => {
    const {posts, recentPosts} = useSelector((state) => state.blog);
    return (
        <>
            {recentPosts?.slice(0, itemShow).map((data) => (
                <div className={`${colSize}`} key={data.id}>
                    <div className={`blog-list ${(data.id % 2  === 0) ? "border-start" : ""}`}>
                        <div className="post-thumbnail">
                            <Link to={process.env.PUBLIC_URL + `/blog-details/${data.id}`}>
                                <img src={media_url(data.image)} alt="Blog Post" 
                                    
                                />
                            </Link>
                        </div>
                        <div className="post-content">
                            <h5 className="title">
                                <Link to={process.env.PUBLIC_URL + `/post/${slugify(data.title)}?id=${data.id}`}>
                                    {data.title}
                                </Link>
                            </h5>
                            <p>{data.excerpt}</p>
                            <Link to={process.env.PUBLIC_URL + `/post/${slugify(data.title)}?id=${data.id}`} className="more-btn">
                                Leer más <FaAngleRight />
                            </Link>
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}

export default BlogListOne;